import { render, staticRenderFns } from "./CAPDownloadPage.vue?vue&type=template&id=4e7103d6&lang=pug&"
import script from "./CAPDownloadPage.vue?vue&type=script&lang=js&"
export * from "./CAPDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports